import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { canVisitPath } from "@/lib/permissions";
import { toast } from "sonner";
import { useEffect, useRef } from "react";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  const toastedFor = useRef("");

  const denied = user && user.pin_verified && !canVisitPath(user, location.pathname);
  // Announce the block once per navigation so the user isn't silently redirected.
  useEffect(() => {
    if (denied && toastedFor.current !== location.pathname) {
      toastedFor.current = location.pathname;
      toast.error("You don't have access to that section. Ask the owner to enable it.");
    }
  }, [denied, location.pathname]);

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-sm text-slate-500" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // PIN is mandatory for every user: if the user has no PIN yet they're routed
  // to /pin to *set one*, otherwise to /pin to *enter it*. Either way they
  // cannot reach the portal without a verified PIN.
  if (!user.pin_verified && location.pathname !== "/pin") {
    return <Navigate to="/pin" replace />;
  }
  // Module-level permission gate — sends them back to the hub (which itself
  // only shows tiles they can open).
  if (denied) return <Navigate to="/" replace />;
  return children;
}
